document.addEventListener("DOMContentLoaded", (event) => {
    // LottieScrollTrigger({
    //     target: "#lottie-container",
    //     path: "https://cdn.shopify.com/s/files/1/0585/3390/4557/files/Sunrise_v01.json?v=1750144958",
    //     speed: "medium",
    //     scrub: 2, // seconds it takes for the playhead to "catch up"
    //     // you can also add ANY ScrollTrigger values here too, like trigger, start, end, onEnter, onLeave, onUpdate, etc. See /docs/v3/Plugins/ScrollTrigger
    //   });
    // // gsap code here!
    const animContainer1 = document.getElementById("lottie-wave-1");
    const animContainer2 = document.getElementById("lottie-wave-2");
    const lottieLink1 = animContainer1.dataset.lottieLink;
    const lottieLink2 = animContainer2.dataset.lottieLink;

    const anim1 = lottie.loadAnimation({
      container: animContainer1,
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: lottieLink1
    });

    const anim2 = lottie.loadAnimation({
      container: animContainer2,
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: lottieLink2
    });
  });